module.exports = __webpack_public_path__ + "static/media/lakepic2.ad91e4d3.png";